module.exports = __webpack_public_path__ + "img/cover-experiencias.718fa02d.jpg";